// Built @Wed, 27 Dec 2023 03:56:16 GMT
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.join.js";
var RegMap = [{
  key: "QQBrowser",
  reg: /(qqbrowser)\/([\d.]+)/
}, {
  key: "QIHU360EE",
  reg: /qihu 360ee/
}, {
  key: "QIHU360SE",
  reg: /qihu 360se/
}, {
  key: "2345Explorer",
  reg: /(2345explorer)\/([\d.]+)/
}, {
  key: "Sogou",
  reg: /(metasr)/
}, {
  key: "Wexin",
  reg: /(micromessenger)\/([\d.]+)/
}, {
  key: "Openlanguage",
  // 开言
  reg: /(openlanguage)\/([\d.]+)/
}, {
  key: "NewsArticle",
  // 头条
  reg: /(newsarticle)\/([\d.]+)/
}, {
  key: "VideoArticle",
  // 西瓜
  reg: /(videoarticle)\/([\d.]+)/
}, {
  key: "Hotsoon",
  // 火山
  reg: /(live_stream)_([\d.]+)/
}, {
  key: "Aweme",
  reg: /(aweme)_([\d.]+)/
}, {
  key: "Lark",
  // 飞书
  reg: /(lark)\/([\d.]+)/
}, {
  key: "PlayStation",
  reg: /(playstation)/
}, {
  key: "BingPreview",
  reg: /(bingpreview)\/([\d.]+)/
}, {
  key: "Baiduspider",
  reg: /(baiduspider-render)\/([\d.]+)/
}, {
  key: "YandexBot",
  reg: /(yandexbot)\/([\d.]+)/
}, {
  key: "Chrome",
  reg: /(chrome)\/([\d.]+)/
}, {
  key: "Safari",
  reg: /(version)\/([\d.]+)\s*(safari)/
}];
var IERegMap = [{
  key: "Trident",
  reg: /(rv:)([\d.]+)/
}, {
  key: "Trident",
  reg: /(msie)\s*([\d.]+)/
}];
function isSupportMP4() {
  var H264_MIMETYPES = ["avc1.42E01E, mp4a.40.2", "avc1.58A01E, mp4a.40.2", "avc1.4D401E, mp4a.40.2", "avc1.64001E, mp4a.40.2", "avc1.42E01E", "mp4v.20.8", "avc1.42E01E, mp4a.40.2", "avc1.58A01E, mp4a.40.2", "avc1.4D401E, mp4a.40.2", "avc1.64001E, mp4a.40.2", "mp4v.20.8, mp4a.40.2", "mp4v.20.240, mp4a.40.2"];
  var result = {
    isSupport: false,
    mime: ""
  };
  if (typeof document === "undefined") {
    return result;
  }
  var a = document.createElement("video");
  if (typeof a.canPlayType === "function") {
    H264_MIMETYPES.map(function(key) {
      if (a.canPlayType('video/mp4; codecs="'.concat(key, '"')) === "probably") {
        result.isSupport = true;
        result.mime += "||".concat(key);
      }
    });
    return result;
  }
  a = null;
  return result;
}
var SPIDER_UA = ["Baiduspider", "YandexBot"];
function checkIsSpider(name, ua) {
  var flag = false;
  SPIDER_UA.map(function(key) {
    if (key === name) {
      flag = true;
    }
  });
  if (/spider/.test(ua)) {
    flag = true;
  }
  return flag;
}
function detect() {
  var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  ua = ua.toLocaleLowerCase();
  var isIOS = /(iphone)/.test(ua) || /(ipad)/.test(ua);
  var isAndroid = /(android)/.test(ua);
  var isWP = /(windows phone)/.test(ua);
  var isMobile = isIOS || isAndroid || isWP;
  var browser = {
    isIOS,
    isAndroid,
    isMobile,
    isPC: !isMobile,
    isPad: /(ipad)/.test(ua)
  };
  var result = isSupportMP4();
  browser.isSupportMP4 = result.isSupport;
  browser.mime = result.mime;
  var appNameKey = "";
  var appVersion = 0;
  var match = [];
  var _regMap = RegMap;
  if (/trident/.test(ua)) {
    _regMap = IERegMap;
  }
  for (var i = 0; i < _regMap.length; i++) {
    match = _regMap[i].reg.exec(ua);
    if (match) {
      appNameKey = _regMap[i].key;
      appVersion = match.length > 2 ? match[2] : "";
      break;
    }
  }
  if (appNameKey) {
    browser["is".concat(appNameKey)] = true;
    browser.name = appNameKey;
    browser.appVersion = appVersion;
  } else {
    var is360 = checkIs360();
    is360 && (browser.name = "360EE");
  }
  if (browser.name && browser.name !== "Trident") {
    var isTrident = /(trident)/.exec(ua);
    if (isTrident) {
      browser.name = browser.name ? "".concat(browser.name, "_Trident") : "Trident";
    }
  }
  browser.isSpider = checkIsSpider(browser.name, ua);
  return browser;
}
function checkIs360() {
  var _navigator = navigator, mimeTypes = _navigator.mimeTypes;
  if (mimeTypes) {
    for (var i = 0; i < mimeTypes.length; i++) {
      if (mimeTypes[i].type && mimeTypes[i].type.indexOf("360") > -1) {
        return true;
      }
      if (mimeTypes[i].type && mimeTypes[i].type.indexOf("application/vnd.chromium.remoting-viewer") > -1) {
        return true;
      }
      if (mimeTypes[i].description && mimeTypes[i].description.indexOf("360") > -1) {
        return true;
      }
    }
    return false;
  }
}
var Browser = typeof navigator !== "undefined" && detect(navigator.userAgent);
function isHevcSupported() {
  if (typeof MediaSource === "undefined" || !MediaSource.isTypeSupported) {
    return false;
  }
  return MediaSource.isTypeSupported('video/mp4;codecs="hev1.1.6.L120.90"') || MediaSource.isTypeSupported('video/mp4;codecs="hev1.2.4.L120.90"') || MediaSource.isTypeSupported('video/mp4;codecs="hev1.3.E.L120.90"') || MediaSource.isTypeSupported('video/mp4;codecs="hev1.4.10.L120.90"');
}
function probeConfigSupported(info) {
  var defaults = {
    supported: false,
    smooth: false,
    powerEfficient: false
  };
  if (!info || typeof navigator === "undefined") {
    return Promise.resolve(defaults);
  }
  if (navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo) {
    return navigator.mediaCapabilities.decodingInfo(info);
  } else {
    var videoConfig = info.video || {};
    var audioConfig = info.audio || {};
    try {
      var videoSupported = MediaSource.isTypeSupported(videoConfig.contentType);
      var audioSupported = MediaSource.isTypeSupported(audioConfig.contentType);
      return Promise.resolve({
        supported: videoSupported && audioSupported,
        smooth: false,
        powerEfficient: false
      });
    } catch (e) {
      return Promise.resolve(defaults);
    }
  }
}
var __support = [1, 1, 1, 1, 1];
function initSupport() {
  __support[0] = Browser.isSupportMP4 ? __support[1] + 1 : __support[1];
  __support[1] = isHevcSupported() ? __support[1] + 1 : __support[1];
  probeConfigSupported({
    type: "file",
    video: {
      contentType: 'video/mp4;codecs="hev1.1.6.L120.90"',
      width: 1920,
      height: 1080,
      bitrate: 1e4,
      framerate: 30
    }
  }).then(function(res) {
    if (res && res.supported) {
      __support[2] = __support[2] + 1;
    } else {
      __support[2] = 1;
    }
  }).catch(function() {
    __support[2] = __support[2] - 1;
  });
}
function getSupport() {
  var _s = parseInt(__support.join(""), 10);
  return _s;
}
initSupport();
export {
  Browser as default,
  getSupport,
  initSupport,
  isHevcSupported,
  probeConfigSupported
};
